import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
  shared: {
    NODE_ENV: z
      .enum(["development", "production", "staging"])
      .default("development"),
    VERCEL_ENV: z.enum(["development", "preview", "production"]).optional(),
    VERCEL_URL: z
      .string()
      .optional()
      .transform((v) => (v ? `https://${v}` : undefined)),
    PORT: z.coerce.number().default(3000),
    NEXT_PUBLIC_APP_NAME: z.string().min(1),
    NEXT_PUBLIC_ANDROID_PACKAGE_NAME: z.string().min(1),
    NEXT_PUBLIC_ANDROID_SHA256_CERT: z.string().min(1),
  },
  server: {
    // Add any server-side env vars here
    SANITY_API_READ_TOKEN: z.string(),
  },
  client: {
    // Client-side vars are already defined
    NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY: z.string(),
    NEXT_PUBLIC_SANITY_PROJECT_ID: z.string(),
    NEXT_PUBLIC_SANITY_DATASET: z.string().default("production").optional(),
    NEXT_PUBLIC_SANITY_API_VERSION: z.string().default("2025-02-10").optional(),
    NEXT_PUBLIC_SANITY_STUDIO_URL: z
      .string()
      .default("http://localhost:3333")
      .optional(),
  },
  runtimeEnv: {
    NODE_ENV: process.env.NODE_ENV,
    VERCEL_ENV: process.env.VERCEL_ENV,
    VERCEL_URL: process.env.VERCEL_URL,
    PORT: process.env.PORT,
    NEXT_PUBLIC_APP_NAME: process.env.NEXT_PUBLIC_APP_NAME,
    NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY:
      process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY,
    NEXT_PUBLIC_ANDROID_PACKAGE_NAME:
      process.env.NEXT_PUBLIC_ANDROID_PACKAGE_NAME,
    NEXT_PUBLIC_ANDROID_SHA256_CERT:
      process.env.NEXT_PUBLIC_ANDROID_SHA256_CERT,
    NEXT_PUBLIC_SANITY_PROJECT_ID: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID,
    NEXT_PUBLIC_SANITY_DATASET: process.env.NEXT_PUBLIC_SANITY_DATASET,
    NEXT_PUBLIC_SANITY_API_VERSION: process.env.NEXT_PUBLIC_SANITY_API_VERSION,
    NEXT_PUBLIC_SANITY_STUDIO_URL: process.env.NEXT_PUBLIC_SANITY_STUDIO_URL,

    SANITY_API_READ_TOKEN: process.env.SANITY_API_READ_TOKEN,
  },
  skipValidation:
    !!process.env.CI ||
    !!process.env.SKIP_ENV_VALIDATION ||
    process.env.npm_lifecycle_event === "lint",
});
